import { render, staticRenderFns } from "./TeacherLanding.vue?vue&type=template&id=2f1db0d8&scoped=true&"
import script from "./TeacherLanding.vue?vue&type=script&lang=ts&"
export * from "./TeacherLanding.vue?vue&type=script&lang=ts&"
import style0 from "./TeacherLanding.vue?vue&type=style&index=0&id=2f1db0d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1db0d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2f1db0d8', component.options)
    } else {
      api.reload('2f1db0d8', component.options)
    }
    module.hot.accept("./TeacherLanding.vue?vue&type=template&id=2f1db0d8&scoped=true&", function () {
      api.rerender('2f1db0d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/classrooms/TeacherLanding.vue"
export default component.exports